import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axiosInstance from "../../services/http/interceptors/GlobalInterciptor";
import color from "../../UI/color";
import { Calendar1Icon, Image } from "lucide-react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import arrowRight from "./image.png";
import timerDate from "../consultant/image.png"
const ListGallary = () => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentGallery, setCurrentGallery] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await axiosInstance.get("/api/mobile/gallery");
        setGalleries(response.data?.data?.data || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchGalleryData();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  const openLightbox = (gallery) => {
    const mediaItems = gallery.photos.map((photo) => ({
      url: photo.photo_url,
      type: photo.photo_url.includes(".mp4") ? "video" : "image",
    }));

    setCurrentGallery(mediaItems);
    setPhotoIndex(0);
    setIsOpen(true);
  };

  const movePrev = () => {
    setPhotoIndex((photoIndex + currentGallery.length - 1) % currentGallery.length);
  };

  const moveNext = () => {
    setPhotoIndex((photoIndex + 1) % currentGallery.length);
  };

  return (
    <Container fluid style={{ backgroundColor: "rgba(220, 253, 255, 1)" }}>
      <div className="p-3 mb-5" style={{ backgroundColor: "rgba(220, 253, 255, 1)" }}>
        <h1 className="text-start mb-5 pt-5 fw-bold" style={{ color: "rgba(47, 84, 102, 1)" }}>
          Discover our amazing <br />
          <span className="pt-3" style={{ color: color.secondred }}>
            Previous Camps
          </span>
        </h1>

        <Row className="mt-4">
          {galleries.map((gallery) => (
            <Col md={4} sm={12} key={gallery.id} className="mb-4">
              <Card
                className="camp-card border-0"
                onClick={() => openLightbox(gallery)}
                style={{ cursor: "pointer" }}
              >
        <div className="image-container">
  <Card.Img
    variant="top"
    src={gallery.photos[0]?.photo_url || "https://via.placeholder.com/300x200"}
    className="camp-img"
    style={{ height: "291.5px", objectFit: "cover" }}
    loading="lazy"
  />
  <div className="image-overlay"></div>
</div>

                <Card.Body className="position-absolute pt-5 mt-5">
                  <Card.Title className="mt-5 pt-3 text-white fw-bold">{gallery.title}</Card.Title>
                  <Card.Text className="text-white fw-bolder d-flex text-start ">
                  <img src={timerDate} className="m-1 d-none d-md-flex " style={{width:"20px"}}  alt="" srcset="" />
                    <span className="ms-1 mt-1">{gallery.date}</span>
                  </Card.Text>
                  <Button variant="white" className="btn-photos border-0" style={{ color: "rgba(19, 178, 188, 1)" }}>
                   
                    <Image color="rgba(19, 178, 188, 1)" className="m-1" size={20} />
                    +{gallery.photos.length - 1} Media{" "}
                    <img src={arrowRight} style={{ width: "17px", height: "17px" }} alt="" />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {isOpen && currentGallery[photoIndex].type === "image" && (
          <Lightbox
            mainSrc={currentGallery[photoIndex].url}
            nextSrc={currentGallery[(photoIndex + 1) % currentGallery.length].url}
            prevSrc={currentGallery[(photoIndex + currentGallery.length - 1) % currentGallery.length].url}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={movePrev}
            onMoveNextRequest={moveNext}
          />
        )}

        {isOpen && currentGallery[photoIndex].type === "video" && (
          <div className="lightbox-video-overlay">
            <button className="prev-button" onClick={movePrev}>❮</button>
            <div className="lightbox-video-container">
              <video controls autoPlay style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                <source src={currentGallery[photoIndex].url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <button className="close-button" onClick={() => setIsOpen(false)}>✖</button>
            </div>
            <button className="next-button" onClick={moveNext}>❯</button>
          </div>
        )}
      </div>

      <style>
        {`
          .lightbox-video-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1050;
          }
          .lightbox-video-container {
            position: relative;
            max-width: 90vw;
            max-height: 90vh;
          }
     .close-button {
          position: absolute;
          top: 10px; /* Ensure it stays visible */
          right: 20px; /* Adjust position for responsiveness */
          background: white;
          color: black;
          border: 2px solid rgba(0, 0, 0, 0.2);
          font-size: 20px; /* Default size */
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: all 0.3s ease-in-out; /* Smooth transition */
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
}

/* Hover Effect */
.close-button:hover {
  background: black;
  color: white;
  border-color: black;
}

/* Responsive Design for Small Screens */
@media (max-width: 768px) {
  .close-button {
    top: 5px;
    right: 10px; /* Adjust for smaller screens */
    font-size: 18px;
    width: 35px;
    height: 35px;
    padding: 6px;
  }
}

/* Responsive Design for Larger Screens */
@media (min-width: 1200px) {
  .close-button {
    top: 15px;
    right: 30px; /* Better alignment for larger screens */
    font-size: 22px;
    width: 45px;
    height: 45px;
  }
}

          .prev-button, .next-button {
            position: absolute;
            top: 50%;
            background: rgba(255, 255, 255, 0.7);
            border: none;
            font-size: 36px;
            cursor: pointer;
            padding: 1px 15px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
          .prev-button {
            left: 30px;
          }
          .next-button {
            right: 30px;
          }
        `}
      </style>
    </Container>
  );
};

export default ListGallary;
